<template>
  <div>
    <filter-item>
      <filter-field-default
        v-model="columnType"
      >
        <option
          v-for="option in columnTypeOptions"
          :value="option.value"
          :key="option.value"
        >{{ option.label }}</option>
      </filter-field-default>
    </filter-item>

    <filter-item>
      <filter-field-default
        v-model="columnCount"
      >
        <option
          v-for="option in columnCountOptions"
          :value="option.value"
          :key="option.value"
        >{{ option.label }}</option>
      </filter-field-default>
    </filter-item>

    <filter-item v-show="hasUserFilter">
      <form-field-checkbox-group
        label="Users"
        is-sidebar-filter
        :items="activeUsers"
        v-model="users"
        @selectAll="selectAllUsers"
        @deselectAll="deselectAllUsers"
      ></form-field-checkbox-group>

    </filter-item>

    <filter-item>
      <form-field-checkbox-group
        label="Campaigns"
        is-sidebar-filter
        :items="campaignOptions"
        v-model="campaigns"
        @selectAll="selectAllCampaigns"
        @deselectAll="deselectAllCampaigns"
      ></form-field-checkbox-group>
    </filter-item>
  </div>
</template>

<script>
import FilterFieldDropdown from "../../../components/filter/old/FilterFieldDropdown";
import utils from "../../../services/utils";

export default {
  components: {FilterFieldDropdown},
  props: {
    hasUserFilter: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      columnType: null,
      columnCount: null,
      campaigns: null,
      users: [],
      columnTypeOptions: [
        { value: 'week',  label: 'Weekly KPIs' },
        { value: 'month', label: 'Monthly KPIs' },
      ],
      columnCountOptions: [
        { value: 0,  label: '1 column' },
        { value: 1,  label: '2 columns' },
        { value: 2,  label: '3 columns' },
        { value: 3,  label: '4 columns' },
        { value: 4,  label: '5 columns' },
        { value: 5,  label: '6 columns' },
        { value: 6,  label: '7 columns' },
        { value: 7,  label: '8 columns' },
        { value: 8,  label: '9 columns' },
        { value: 9,  label: '10 columns' },
        { value: 10, label: '11 columns' },
        { value: 11, label: '12 columns' },
        { value: 12, label: '13 columns' },
      ]
    }
  },
  computed: {
    campaignOptions() {
      return [
        { id: null, label: 'No Campaign' },
        ...this.$store.getters.activeCampaigns,
      ];
    },
    activeUsers() {
      return this.$store.getters.activeUsers.map(user => {
        return {
          id: user.id,
          label: user.full_name
        }
      })
    }
  },
  mounted() {
    this.resetFilters();
  },
  methods: {
    applyFilters() {
      this.$store.commit('statsKpi/setOneFilter', ['columnType', this.columnType])
      this.$store.commit('statsKpi/setOneFilter', ['columnCount', this.columnCount])
      this.$store.commit('statsKpi/setOneFilter', ['campaigns', this.campaigns])
      this.$store.commit('statsKpi/setOneFilter', ['users', this.users])
      this.$store.dispatch('updateUserAppFilter');
    },
    resetFilters() {
      this.columnType = this.$store.state.statsKpi.filters.columnType;
      this.columnCount = this.$store.state.statsKpi.filters.columnCount;
      this.campaigns = this.$store.state.statsKpi.filters.campaigns;
      this.users = this.$store.state.statsKpi.filters.users;
    },
    selectAllCampaigns() {
      const campaigns = utils.clone(this.$store.getters.activeCampaigns);
      this.campaigns = campaigns.map(c => c.id);
      this.campaigns.push(null);
    },
    deselectAllCampaigns() {
      this.campaigns = [];
    },
    selectAllUsers() {
      this.users = this.activeUsers.map(user => user.id)
    },
    deselectAllUsers() {
      this.users = []
    },
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

.filter_item {
  padding: 0 8px 12px !important;
}
</style>
